// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { dateToString, price } from './components/filters/'
import { CreateRouter } from './router'
import routerconfig from './router/config'
import api from './api'
import { CreateStore } from './store'
import { sync } from 'vuex-router-sync'
/* semantic ui */
import '../semantic/dist/semantic.min.css'
import 'flatpickr/dist/flatpickr.css'
/* swiper */
import 'swiper/dist/css/swiper.css'
import './assets/styles/sprite.css'
import './assets/styles/site.less'
import GSignInButton from 'vue-google-signin-button'

Vue.use(GSignInButton)

Vue.config.productionTip = false
Vue.prototype.RouterConfig = routerconfig

if (process.browser) {
  const VueAwesomeSwiper = require('vue-awesome-swiper')
  Vue.use(VueAwesomeSwiper)
}

Vue.filter('dateToString', (dateStr, fmt) => {
  return dateToString(dateStr, fmt)
})
Vue.filter('price', (priceStr) => {
  return price(priceStr)
})

export function CreateApp () {
  const router = new CreateRouter()
  const store = new CreateStore()

  sync(store, router)

  const app = new Vue({
    // el: '#app',
    router,
    api,
    store,
    template: '<App/>',
    render: h => h(App)
  })
  return { app, router, store }
}



// WEBPACK FOOTER //
// ./src/main.js